export class NumberOptions {
  constructor(public decimals: number, public minDecimals: number, public step: number) {}
}
